import React, { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

const PaginationInput = ({
	currentpage,
	totalpages,
	docsToSHow,
	setCurrentPage,
	setDocumentsBulk = () => {},
	setAllChecked = () => {},
}) => {
	const [currentPageNumber, setCurrentPageNumber] = useState(1)
	/* ******************* REDUX STORE ******************* */

	/* ******************* END REDUX STORE ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	const handlePageNumberChange = (e) => {
		setCurrentPageNumber(e.target.value)
		if (e.target.value !== "" && Number(e.target.value) > 0 && Number(e.target.value) <= totalpages) {
			setCurrentPage(Number(e.target.value))
			setDocumentsBulk([])
			setAllChecked(false)
		}
	}

	const handlePageNumberBlur = (e) => {
		const pageNumber = Math.sign(e.target.value)
		if (!pageNumber || Number(e.target.value) > totalpages) {
			setCurrentPageNumber(currentpage)
		}
	}

	useEffect(() => {
		setCurrentPageNumber(currentpage)
	}, [currentpage])
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	return (
		<Fragment>
			{docsToSHow.count > 0 && currentpage !== null && !Number.isNaN(totalpages) ? (
				<div className="col-12 d-flex justify-content-center fs-pagination">
					<br />
					<p>
						<input
							data-cy="input_exclude_terms"
							type="number"
							name="inputNumber"
							id="number"
							className="rounded inputFilterNegative"
							style={{ marginRight: "5px", width: "75px" }}
							min={1}
							max={totalpages}
							onChange={handlePageNumberChange}
							onBlur={handlePageNumberBlur}
							value={currentPageNumber}
						/>
						of <b>{totalpages}</b>
					</p>
				</div>
			) : null}
		</Fragment>
	)
}

export default PaginationInput
